import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import { FC } from "react";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import type { MaterialSubcategory } from "../../../../http/envelopeDesigner/types/materialSubcategory";
import { useMaterialClassificationApi } from "../../../../http/envelopeDesigner/useAdminEnvelopeDesigner";
import MaterialSubcategoryFormDialog from "./MaterialSubcategoryFormDialog";

// The subcategories of the material library: a hidden one hides its materials (user side, except the ones a
// calculation uses); delete refused by the server while a material is of it.
const MaterialSubcategoriesTab: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.envelopeDesignerModule.admin;
  const { subcategories } = useMaterialClassificationApi();

  return (
    <AdminCrudTable<MaterialSubcategory>
      filterPrefix="material_subcategories"
      useList={subcategories.useSearch}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.category}</TableHeadCell>
          <TableHeadCell align="left">{t.condCategory}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.category}</TableCell>
          <TableCell>{item.condCategory ?? "—"}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) => subcategories.updateVisibility(item.code, { visibility }),
        updateOrder: (item, order) => subcategories.updateOrder(item.code, { order }),
      }}
      onDelete={(item) => subcategories.remove(item.code)}
      deleteTitle={t.subcategory}
      canAdd
      renderForm={(item, onClose) => <MaterialSubcategoryFormDialog subcategory={item} onClose={onClose} />}
    />
  );
};

export default MaterialSubcategoriesTab;
